// Year navigation footer: previous-year, refresh and next-year controls inside
// a tinted box.
import { Box, Flex, IconButton, Spinner, useColorModeValue } from "@chakra-ui/react";
import { MdChevronLeft, MdChevronRight, MdRefresh } from "react-icons/md";

/**
 * Renders previous/refresh/next year controls. All buttons are disabled while
 * data is loading; the refresh button shows a spinner instead.
 * @param {Object} props - loading (bool), onPrev, onNext, onRefresh callbacks
 * @returns {React.ReactElement}
 */
export default function YearNavFooter({ loading, onPrev, onNext, onRefresh }) {
  const boxBg = useColorModeValue("secondaryGray.300", "navy.700");
  const iconColor = useColorModeValue("secondaryGray.700", "white");
  return (
    <Flex mt="14px" p="8px 16px" borderRadius="14px" bg={boxBg} justify="space-between" align="center">
      <IconButton aria-label="Année précédente" size="sm" variant="ghost" color={iconColor}
        isDisabled={loading} onClick={onPrev} icon={<Box as={MdChevronLeft} fontSize="22px" />} />
      <IconButton aria-label="Rafraîchir" size="sm" variant="ghost" color={iconColor}
        isDisabled={loading} onClick={onRefresh}
        icon={loading ? <Spinner size="sm" /> : <Box as={MdRefresh} fontSize="18px" />} />
      <IconButton aria-label="Année suivante" size="sm" variant="ghost" color={iconColor}
        isDisabled={loading} onClick={onNext} icon={<Box as={MdChevronRight} fontSize="22px" />} />
    </Flex>
  );
}
